import type { TApiDisciplineRequest, TApiDisciplineResponse, TApiDisciplineSettingsResponse, TDiscipline, TRawDiscipline } from "@/models/discipline.model"
import { parse } from "date-fns"
import { languageParser } from "../language.mapper"

export class DisciplineMapper {
  static toDto(rawData: TApiDisciplineResponse[] | null): TDiscipline[] {
    if (!rawData) {
      return []
    }

    const mappedData: TRawDiscipline[] = rawData.map((discipline: TApiDisciplineResponse) => ({
      id: discipline.order,
      rscCode: discipline.code,
      metadata: {
        description: {
          long: discipline.description?.long || "",
          short: discipline.description?.short || "",
          language: discipline.description?.language || "eng",
        },
        code: discipline.code,
      },
      events: 0,
      icon: "", // No hay icono en la nueva estructura
      venues: [],
      startDate: undefined,
      endDate: undefined,
    }))

    return mappedData.map(item => ({
      id: item.id,
      code: item.rscCode,
      name: item.metadata.description?.long,
      events: item.events,
      icon: item.icon,
      description: {
        long: item.metadata.description?.long || "",
        short: item.metadata.description?.short || "",
        language: item.metadata.description?.language || "eng",
      },
      venues: item.venues.map(venue => ({
        id: venue.id,
        code: venue.code,
        description: venue.description,
      })),
      dateSettings: {
        startDate: item.startDate ? parse(item.startDate, "yyyy-MM-dd'T'HH:mm:ss", new Date()) : undefined,
        endDate: item.endDate ? parse(item.endDate, "yyyy-MM-dd'T'HH:mm:ss", new Date()) : undefined,
      },
    }))
  }

  static disciplineSettingsToDto(rawData: TApiDisciplineSettingsResponse[]): TDiscipline[] {
    if (!rawData) {
      return []
    }

    console.log("DisciplineMapper.disciplineSettingsToDto", rawData)

    return rawData.map((discipline: TApiDisciplineSettingsResponse, index: number) => ({
      id: index,
      code: discipline.disciplineCode,
      name: discipline.disciplineCode,
      events: 0,
      icon: "", // No hay icono en la nueva estructura
      description: {
        long: discipline.disciplineCode || "",
        short: discipline.disciplineCode || "",
        language: "eng",
      },
      venues: discipline.venues.map((venue, venueIndex: number) => ({
        id: venueIndex,
        code: venue.code,
        description: {
          long: venue.description?.eng?.long || venue.code,
          short: venue.description?.eng?.short || venue.code,
          language: "eng",
        },
      })),
      dateSettings: {
        startDate: discipline.dateInfo.startDate ? parse(discipline.dateInfo.startDate, "yyyy-MM-dd'T'HH:mm:ss", new Date()) : undefined,
        endDate: discipline.dateInfo.endDate ? parse(discipline.dateInfo.endDate, "yyyy-MM-dd'T'HH:mm:ss", new Date()) : undefined,
      },
    }))
  }

  static disciplineSettingsToApi(rawData: TApiDisciplineSettingsResponse[]): TApiDisciplineRequest[] {
    if (!rawData) {
      return []
    }

    console.log("DisciplineMapper.disciplineSettingsToDto", rawData)

    return rawData.map((discipline: TApiDisciplineSettingsResponse, index: number) => ({
      id: index,
      code: discipline.disciplineCode,
      name: discipline.disciplineCode,
      events: 0,
      icon: "", // No hay icono en la nueva estructura
      description: {
        long: discipline.disciplineCode || "",
        short: discipline.disciplineCode || "",
        language: "eng",
      },
      venues: discipline.venues.map((venue, venueIndex: number) => ({
        id: venueIndex,
        code: venue.code,
        description: {
          long: venue.description?.eng?.long || venue.code,
          short: venue.description?.eng?.short || venue.code,
          language: "eng",
        },
      })),
      dateSettings: {
        startDate: discipline.dateInfo.startDate ? discipline.dateInfo.startDate : undefined,
        endDate: discipline.dateInfo.endDate ? discipline.dateInfo.endDate : undefined,
      },
      order: index,
    }))
  }

  static disciplineSettingToDto(rawData: TApiDisciplineSettingsResponse): TDiscipline {
    console.log("DisciplineMapper.disciplineSettingToDto", rawData)
    return {
      id: 0,
      code: rawData.disciplineCode,
      name: rawData.disciplineCode,
      events: 0,
      icon: "", // No hay icono en la nueva estructura
      description: {
        long: rawData.disciplineCode || "",
        short: rawData.disciplineCode || "",
        language: "eng",
      },
      venues: rawData.venues.map((venue, venueIndex: number) => ({
        id: venueIndex,
        code: venue.code,
        description: languageParser(venue.description),
      })),
      dateSettings: {
        startDate: rawData.dateInfo.startDate ? parse(rawData.dateInfo.startDate, "yyyy-MM-dd'T'HH:mm:ss", new Date()) : undefined,
        endDate: rawData.dateInfo.endDate ? parse(rawData.dateInfo.endDate, "yyyy-MM-dd'T'HH:mm:ss", new Date()) : undefined,
      },
    }
  }
}
